import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const FeatureCards = () => {
  const features = [
    {
      id: 1,
      title: 'تهیه انواع اوراق قضایی',
      description:
        'دریافت پاسخ‌های سریع و دقیق به سوالات حقوقی شما با استفاده از فناوری پیشرفته هوش مصنوعی',
      icon: 'Zap',
      color: 'bg-accent',
      gradient: 'from-accent/10 to-accent/5',
    },
    {
      id: 2,
      title: 'تاییدیه وکلا حرفه ای',
      description:
        'دریافت پاسخ‌های سریع و دقیق به سوالات حقوقی شما با استفاده از فناوری پیشرفته هوش مصنوعی',
      icon: 'Zap',
      color: 'bg-accent',
      gradient: 'from-accent/10 to-accent/5',
    },
    {
      id: 3,
      title: 'ارتباط با وکلای متخصص',
      description:
        'دسترسی به شبکه‌ای از وکلای مجرب و متخصص در زمینه‌های مختلف حقوقی برای مشاوره تخصصی',
      icon: 'Users',
      color: 'bg-success',
      gradient: 'from-success/10 to-success/5',
    },
    {
      id: 4,
      title: 'تحلیل اسناد و قراردادها',
      description:
        'بررسی و تحلیل هوشمند اسناد حقوقی، قراردادها و مدارک با ارائه نظرات کارshناسی دقیق',
      icon: 'FileText',
      color: 'bg-secondary',
      gradient: 'from-secondary/10 to-secondary/5',
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            مزایای استفاده از ایران‌داد
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            با ویژگی‌های منحصر به فرد ما، تجربه متفاوتی از مشاوره حقوقی خواهید
            داشت
          </p>
        </motion.div>

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features?.map((feature, index) => (
            <motion.div
              key={feature?.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              className="group">
              <div
                className={`relative bg-gradient-to-br ${feature?.gradient} p-6 lg:p-8 rounded-2xl border border-border hover:border-border/80 transition-all duration-300 shadow-subtle hover:shadow-moderate h-full`}>
                {/* Feature Icon */}
                <div
                  className={`inline-flex items-center justify-center w-14 h-14 ${feature?.color} rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300 shadow-subtle`}>
                  <Icon name={feature?.icon} size={28} color="white" />
                </div>

                {/* Feature Content */}
                <h3 className="text-xl font-bold text-foreground mb-4 group-hover:text-primary transition-colors duration-300">
                  {feature?.title}
                </h3>

                <p className="text-muted-foreground leading-relaxed">
                  {feature?.description}
                </p>

                {/* Decorative Element */}
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-primary/10 rounded-full group-hover:bg-primary/20 transition-colors duration-300"></div>

                {/* Bottom Border Animation */}
                <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-primary to-secondary rounded-full transition-all duration-300 w-0 group-hover:w-full"></div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-center mt-12">
          <p className="text-muted-background mb-6">
            آماده تجربه مشاوره حقوقی نوین هستید؟
          </p>
          <div className="inline-flex items-center px-6 py-3 bg-primary/10 text-primary rounded-full text-sm font-medium">
            <Icon name="Sparkles" size={16} className="ml-2" />
            بیش از ۱۰۰ نوع سوال حقوقی پشتیبانی می‌شود
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureCards;
